import type { MutableRefObject, Ref } from 'react';
import { useLayoutEffect, useRef } from 'react';

/**
 * A hook for merging multiple refs into one ref.
 */
export function useCombinedRefs<T>(...refs: readonly Ref<T>[]): MutableRefObject<T | null> {
	const targetRef = useRef<T>(null);

	useLayoutEffect(() => {
		refs.forEach((ref) => {
			if (!ref) return;

			if (typeof ref === 'function') {
				ref(targetRef.current ?? null);
			} else {
				// @ts-expect-error: https://github.com/DefinitelyTyped/DefinitelyTyped/issues/31065
				ref.current = targetRef.current;
			}
		});
	}, [refs]);

	return targetRef;
}
